import {Pipe, PipeTransform} from "@angular/core";
import {DateTimeFormatter, TemporalAccessor} from "js-joda";

const dateFormat = DateTimeFormatter.ofPattern("dd.MM.yyyy");

@Pipe({
    name: 'localDate',
    pure: true,
    standalone: true
})
export class LocalDatePipe implements PipeTransform {
    transform(value: TemporalAccessor | null) {
        return value && dateFormat.format(value);
    }
}
